// src/api/aiApi.js
import axiosConfig from './axiosConfig';

export const aiApi = {
    getConversations: async () => {
        const response = await axiosConfig.get('/ai/conversations');
        return response.data;
    },

    createConversation: async (title = 'Nuova conversazione') => {
        const response = await axiosConfig.post('/ai/conversations', { title });
        return response.data;
    },

    getConversation: async (id) => {
        const response = await axiosConfig.get(`/ai/conversations/${id}`);
        return response.data;
    },

    sendMessage: async (conversationId, message) => {
        const response = await axiosConfig.post(`/ai/conversations/${conversationId}/message`, { message });
        return response.data;
    },

    // Invia messaggio + file (PDF o immagine)
    sendMessageWithFile: async (conversationId, file, message = '') => {
        const formData = new FormData();
        formData.append('file', file);
        if (message) formData.append('message', message);
        const response = await axiosConfig.post(
            `/ai/conversations/${conversationId}/message-file`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        return response.data;
    },

    deleteConversation: async (id) => {
        const response = await axiosConfig.delete(`/ai/conversations/${id}`);
        return response.data;
    },

    analyzeProject: async (projectId) => {
        const response = await axiosConfig.post(`/ai/projects/${projectId}/analyze`);
        return response.data;
    },

    getSuggestions: async () => {
        const response = await axiosConfig.get('/ai/suggestions');
        return response.data;
    },

    getUsage: async () => {
        const response = await axiosConfig.get('/ai/usage');
        return response.data;
    },

    getCosts: async (month) => {
        const params = month ? { month } : {};
        const response = await axiosConfig.get('/ai/costs', { params });
        return response.data;
    },

    // ✅ Planner 3D — backend-proxied, API key mai esposta al browser
    plannerAnalysis: async ({ structureType, structureLabel, dimensions, budget, currency, organizationName }) => {
        const response = await axiosConfig.post('/ai/planner', {
            structureType, structureLabel, dimensions, budget, currency, organizationName,
        });
        return response.data;
    },
};